import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const ArrowLeft = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.29748 16.7111C4.28095 16.6948 4.26498 16.6779 4.24961 16.6605C4.1827 16.5847 4.12924 16.5011 4.08924 16.413C4.03192 16.287 4 16.1469 4 15.9995C4 15.852 4.03192 15.712 4.08924 15.5859C4.12924 15.4978 4.1827 15.4143 4.24961 15.3385C4.26498 15.321 4.28095 15.3041 4.29748 15.2878L14.1924 5.39287C14.5829 5.00234 15.2161 5.00234 15.6066 5.39287C15.9972 5.78339 15.9972 6.41656 15.6066 6.80708L7.41424 14.9995H26C26.5523 14.9995 27 15.4472 27 15.9995C27 16.5518 26.5523 16.9995 26 16.9995H7.41424L15.6066 25.1919C15.9972 25.5824 15.9972 26.2155 15.6066 26.6061C15.2161 26.9966 14.5829 26.9966 14.1924 26.6061L4.29748 16.7111Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)
export default ArrowLeft
